import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useClinicLabPartnersAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const [labPartners, setLabPartners] = useState<any[]>([]);

  const configuration = useConfiguration();
  const execute = useCallback(
    async (clinicId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${LAB_REPORT?.LAB_PARTNER_LIST?.baseURL}${clinicId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setLabPartners(res.data.data?.length > 0 ? res.data.data : []);
              return { status: true, data: res.data.data?.length > 0 ? res.data.data : [] };
            } else {
              setLabPartners([]);
            }
          })
          .catch((e: AxiosError) => {
            setLabPartners([]);
            sendCurl(e.config["curlCommand"]);
            return { status: false, data: [] };
          });
        return response;
      } catch (e: any) {
        setLabPartners([]);
      }
    },
    [dispatch],
  );
  return { execute, labPartners };
};
